import { TFunction } from "i18next";
import { template } from "lodash";
import { TypeAttributes } from "rsuite/esm/internals/types";

import { formatUtcDateTimeWithNameOfMonth } from "utils/date-helper";

import { SecretExpiration } from "store/environments/tenants/tenant-configurations/tenant-configurations-types";
import { SecretExpirationStatus } from "store/environments/tenants/tenants-types";

export interface SecretExpirationMessage {
    type: TypeAttributes.Status;
    description: string;
}

const getMessageType = (
    status: SecretExpirationStatus
): TypeAttributes.Status | null => {
    switch (status) {
        case SecretExpirationStatus.Warning:
            return "warning";
        case SecretExpirationStatus.Error:
            return "error";
        default:
            return null;
    }
};

export const getSecretExpirationMessage = (
    secretExpiration: SecretExpiration | null | undefined,
    t: TFunction
): SecretExpirationMessage | null => {
    if (
        !secretExpiration ||
        secretExpiration.status === null ||
        secretExpiration.timeInDays === null
    ) {
        return null;
    }

    const type = getMessageType(secretExpiration.status);
    if (!type) {
        return null;
    }

    const expiration = template(
        t("tenantConfig.studio.clientSecret.expirationMessage")
    )({ expirationDays: secretExpiration.timeInDays });

    const rotation = secretExpiration.rotationDate
        ? template(
              t("tenantConfig.studio.clientSecret.automaticRotationMessage")
          )({
              expirationDateOffset: formatUtcDateTimeWithNameOfMonth(
                  new Date(secretExpiration.rotationDate)
              ),
          })
        : t("tenantConfig.studio.clientSecret.manualRotationMessage");

    return { type, description: `${expiration} ${rotation}` };
};
